<template>

<core-modal v-on:close="onCancelClick" icon="caret-left">

	<template v-slot:head>

		Delete Tag

	</template>

	<template v-slot:default>

		<p v-if="!isFamily">Are you sure you wish to delete the tag <b>{{ tag.text }}</b>?</p>

		<p v-if="isFamily">Are you sure you wish to delete the tag <b>{{ tag.text }}</b> from the family <b>{{ family.name }}</b>?</p>

	</template>

	<template v-slot:foot>

		<core-button theme="red" v-on:click.native="onConfirmClick" :loading="is.loading">Confirm</core-button>
		<core-button theme="blue" v-on:click.native="onCancelClick">Cancel</core-button>

	</template>

</core-modal>

</template>

<script>

export default {

	props: ['data'],

	data: function() {

		return {

			is: {
				loading: false
			}

		}

	},

	computed: {

		tag: function() {

			return this.$store.getters['data/tags'][this.data.tag]

		},

        family: function() {

            return (this.isFamily) ? this.$_.find(this.$store.getters['data/tagFamilies/list'], function(family) {

                return family.id === this.tag.family

            }.bind(this)) : false

        },

		isFamily: function() {

			return this.tag.family

		}

	},

	methods: {

		onConfirmClick: function() {

			this.is.loading = true

			this.$store.dispatch('api/tags/delete', {
				tag: this.data.tag
			}).then(function(tag) {

				var isFamily = this.isFamily

				this.$store.commit('data/tags/remove', [tag])

				this.$emit('close')

				if (isFamily) {

					this.$pubsub.$emit('open.modal', {
						id: 'tagFamilyManage',
						family: isFamily
					})

				} else {

					this.$pubsub.$emit('open.modal', {
						id: 'tagManage'
					})

				}

			}.bind(this), function() {

				this.is.loading = false

			}.bind(this)) 

		},

		onCancelClick: function() {

			this.$emit('close')

			this.$pubsub.$emit('open.modal', {
				id: 'tagEdit',
				tag: this.data.tag
			})

		}

	}

}

</script>

<style scoped>

</style>